
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

import Toaster from 'v-toaster'
import ToggleButton from 'vue-js-toggle-button'

// You need a specific loader for CSS files like https://github.com/webpack/css-loader
import 'v-toaster/dist/v-toaster.css'
import VModal from 'vue-js-modal'

Vue.use(Toaster, {timeout: 5000})
Vue.use(VModal, {componentName: "v-modal"})
Vue.use(ToggleButton)

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

require('./filters.js');

// initiate the eventBus object
window.eventBus = new Vue();

Vue.component('error-state', require('./vue/components/global/ErrorState').default)
Vue.component('config-manager', require('./vue/components/config-manager/ConfigManager').default)
Vue.component('template-manager', require('./vue/components/template-manager/TemplateManager').default)
Vue.component('pdf-preview-manager', require('./vue/components/template-generator/PdfPreviewManager').default)
Vue.component('template-adjustments', require('./vue/components/template-generator/TemplateAdjustments').default)
Vue.component('generate-documents', require('./vue/components/template-generator/GenerateDocuments').default)
Vue.component('document-generator', require('./vue/components/template-generator/DocumentGenerator').default)
Vue.component('archive-download', require('./vue/components/template-generator/ArchiveDownload').default)
Vue.component('general-error', require('./vue/components/template-generator/GeneralError').default)

if (typeof Lang !== 'undefined') {
    Vue.prototype.$lang = Lang
}

// initiate the Vue Root instance
const app = new Vue({
    el: '#app',
})

